module.exports = __webpack_public_path__ + "img/Argentine-Italian.c52054ac.svg";